import React, { Component } from "react";
import { Col, Container, Row } from "reactstrap";
import DarkCarousel from "../../components/DarkCarousel/DarkCarousel";
import SearchBar from "../../components/SearchBar/SearchBar";
import Ready2GoImg from "../../assets/img/r2gsmall.webp";
import HomeVideo from "../../assets/home-video.mp4";
import XCaret from "../../assets/img/xcaret-logo.webp";
import "./Home.css";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAdminPage: false,
    };
  }

  componentDidMount() {
    this.props.isAdminPage(false);
  }

  handleRecorrido() {
    window.open("https://landing-hoteles-xcaret.firstview.us/es", "_blank");
  }

  render() {
    return (
      <div className="home-space">
        <div className="hero-space">
          <SearchBar history={this.props.history} />
        </div>
        <div className="home-video-container">
          <video autoPlay loop muted className="home-video" src={HomeVideo} />
          <div className="home-video-mask" />
          <div className="home-video-centered-container">
            <img src={XCaret} alt="xcaret" className="home-video-logo" />
            <button className="home-video-button" onClick={() => this.handleRecorrido()}>
              RECORRIDO VIRTUAL
            </button>
          </div>
        </div>
        <Container className="light-container">
          <Row className="container-bigger">
            <Col lg="12">
              <img src={Ready2GoImg} alt="ready2go" className="ready2goimg" />
              <p className="subtitle">
                Móntate en un viaje ya preparado para ti con las mejores opciones de estadía y
                recorridos.
              </p>
              <div className="carousel-contain">
                <DarkCarousel ready count="4" history={this.props.history} />
              </div>
            </Col>
          </Row>
        </Container>

        {/* <Container className="panaViajero-Background">
         <div className="panaViajero-Background">
            <h1 className="view-PanaTitle">¿QUIERES VIAJAR<br></br> PERO NO SABES A DÓNDE?</h1>
            </div>

          <div className="panaViajero-Background">
            <h3 className="view-subTitlePana">Te podemos ayudar con eso.</h3>
            </div>

          <div className="panaViajero-Background"> 
            <p className="pana-Paragraph"><b>Intenta nuestro nuevo asesor virtual aqui!</b><br/>
              Con solo contestar 6 preguntas podemos hacerte<br></br>
              una recomendación ajustada a tus gustos.
             
         
            </p>
            <Button type="submit" className="panaViajero-btn" onClick={()=>this.props.history.push("/panaviajero")}>El Pana Viajero</Button>
            </div>
          </Container> */}
      </div>
    );
  }
}
export default Home;
